import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AdminServiceService } from '../../service/admin-service.service';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss'],
})
export class LocationComponent implements OnInit {
  @Input() edit = undefined;
  @Input() showCity: boolean = true;
  @Input() countries: any[] = [];

  public stateName = '';
  public stateCountry = '';
  public cityData = [];
  public code = ''
  public iso = '';

  constructor(
    private adminSv: AdminServiceService,
    private modalController: ModalController
  ) { }

  ngOnInit() {
    if(this.edit){
      this.stateName = this.edit.name;
      this.cityData = this.edit.cities;
      this.stateCountry = this.edit.country_id || 0;
      this.code = `${this.edit.code}` || '';
      this.iso = `${this.edit?.iso}` || '';
    }
  }

  addCity(){
    this.cityData.push({name: '', id: 0});
  }

  async submit(){
    try{
      const stateBody: any = {
        name: this.stateName,
        data: JSON.stringify(this.cityData),
        parent: 1
      };
      this.edit && (stateBody.id = this.edit.id);
      let uri =  'state';
      if(!this.showCity){
        stateBody.code = this.code;
        stateBody.iso = this.iso.toLocaleLowerCase();
        uri = 'country';
      }else{
        stateBody.parent = this.stateCountry;
      }

      this.adminSv.storeState(stateBody, !this.edit ? 'store' : 'update', uri).subscribe(async (res: any) => {
        if(this.edit){
          await this.modalController.dismiss(res.item, 'update');
        }else{
          await this.modalController.dismiss(res.item);
        }
      })
    }catch(err){
      console.error(err);
    }
  }

}
